import request from '../utils/request'

export function selectMainBanner(data) {
  return request({
    url: '/api/banner/main',
    method: 'post',
    data,
  })
}


export function selectMainBannerList(data) {
  return request({
    url: '/api/banner/list',
    method: 'post',
    data,
  })
}


export function selectLocationBanner(data) {
  return request({
    url: '/api/banner/location/list',
    method: 'post',
    data,
  })
}
